import { getConst } from './xp.v1'

export const WZ = window.IWangZhe
export const WZUtils = WZ.Utils

export const WZServices = window.WZServices

export const {
  getServerTime,
  getErrorMsg,
  setErrorMsg,
  inWeiXin,
  inWxMp,
  inWxPc,
  inMQQ,
  inApp,
  inSubApp,
  inWZApp,
  inXSApp,
  inDKApp,
  inPC,
  inMobile,
  inIOS,
  inAndroid,
  inEnvDev,
  inEnvTest,
  inEnvPrd,
  inXSWeb,
  inWZWeb,
  inZFFWeb
} = WZUtils

export function getCorpName() {
  const CONST = getConst()
  return CONST.corp || 'iwangzhe'
}

export function makeShare(info) {
  info = info || {}
  let { title, url, image, description } = info
  title = title || document.title
  url = url || location.href
  image = image || 'https://imgcdn-prd.pydp888.com/file/0/1/200003/20201109/9f7d525e039ba8d9ecb296cfcde3293c.png'
  description = description || ''
  if (inWeiXin()) {
    WZ.wxInit({
      shareUrl: location.href,
      shareImgUrl: image,
      shareTitle: title,
      shareDescription: description
    })
  } else if (inApp()) {
    const kStat = window.kStat
    if (kStat && kStat.makeShare) {
      kStat.makeShare({
        url,
        image,
        title,
        description
      })
    }
  }
}
